package features.watch

internal enum class WatchCacheDecision {
    KEEP,
    DROP,
}

/**
 * Watch history belongs to the account on the server.
 * Playback is available only while logged in, so there is no guest history to keep.
 * The local table is a mirror of the current account and is dropped on logout
 * or when another account is signed in.
 */
internal fun watchCacheDecision(owner: String?, userId: String?): WatchCacheDecision {
    if (userId != null && owner == userId) return WatchCacheDecision.KEEP
    return WatchCacheDecision.DROP
}
